import e from "react";
import { c as r, t as o } from "./useKeyDown-88662051.mjs";
import { B as c } from "./useClickOutside-55c64a80.mjs";
import { I as g, a as Q } from "./Image-be3826ec.mjs";
import "./ImageContext-57256dc1.mjs";
const h = "article-quote", E = "article-quote__quote", L = "article-quote__name", q = "article-quote--lightBlue", y = "article-quote--lightGrey", C = "article-quote__vertical-credits", _ = "article-quote__curtain-show", a = {
  articleQuote: h,
  articleQuoteQuote: E,
  articleQuoteName: L,
  articleQuoteLightBlue: q,
  articleQuoteLightGrey: y,
  articleQuoteVerticalCredits: C,
  articleQuoteCurtainShow: _
};
function I(t) {
  const { name: i, quote: u, variant: l, id: n, i18n: s } = t, { creditsLabel: m = "Credits" } = s ?? {}, d = l === "color" ? t.color === "lightGrey" ? a.articleQuoteLightGrey : a.articleQuoteLightBlue : void 0;
  return /* @__PURE__ */ e.createElement(
    c,
    {
      id: n,
      topPadding: c.Padding.LARGE,
      bottomPadding: c.Padding.LARGE,
      className: r(a.articleQuote, d),
      "data-testid": "article-quote"
    },
    l === "image" ? /* @__PURE__ */ e.createElement(
      N,
      {
        credits: t.credits,
        imageData: t.imageData
      }
    ) : null,
    /* @__PURE__ */ e.createElement(c.Content, { style: { zIndex: 1 } }, /* @__PURE__ */ e.createElement(
      "blockquote",
      {
        className: r(o.headingSection, a.articleQuoteQuote)
      },
      u
    ), /* @__PURE__ */ e.createElement("p", { className: r(o.textsLeadText, a.articleQuoteName) }, i), l === "image" ? /* @__PURE__ */ e.createElement(
      "p",
      {
        className: r(
          a.articleQuoteVerticalCredits,
          o.textsCaption
        )
      },
      m,
      ": ",
      t.credits
    ) : null)
  );
}
function N({
  credits: t,
  imageData: i
}) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    g,
    {
      credits: t,
      src: i.imageSrc,
      width: i.width,
      height: i.height,
      altText: t ?? "",
      imageLoader: i.imageLoader,
      styling: Q.ARTICLE_QUOTE
    }
  ), /* @__PURE__ */ e.createElement("div", { className: r(a.articleQuoteCurtainShow) }));
}
export {
  I as default
};
//# sourceMappingURL=ArticleQuote.js.map
